import service from "@/store/services/event-packages-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  eventPackage: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, eventPackage) => {
    state.eventPackage = eventPackage;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((eventPackage) => {
      commit("SET_RESOURCE", eventPackage);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((eventPackage) => {
      commit("SET_RESOURCE", eventPackage);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((eventPackage) => {
      commit("SET_RESOURCE", eventPackage);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },

  getRegistrationsReport({ commit, dispatch }, params) {
    return service.getRegistrationsReport(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  eventPackage: (state) => state.eventPackage,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((eventPackage) => ({
      id: eventPackage.id,
      name: eventPackage.full_package_name,
    }));
  },
};

const eventPackages = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default eventPackages;
